import { useEffect, useState, useMemo } from 'react'
import { useFlags } from 'launchdarkly-react-client-sdk'
import { useLazyQuery } from '@apollo/react-hooks'

import { UNPROTECTED_ROUTES } from 'constants/unprotectedRoutes'

import query from './flagValues.graphql'

const useLDFlags = () => {
  const location = window.location.pathname
  const skipQuery = useMemo(() => UNPROTECTED_ROUTES.includes(location), [
    location,
  ])

  const [getFlags, { data: flagValues, loading: loadingValues }] = useLazyQuery(
    query
  )
  const [LDOffline, setLDOffline] = useState(false)

  const flagsLD = useFlags()

  const loading = useMemo(
    () => !Object.values(flagsLD).some(flagValue => flagValue !== undefined),
    [flagsLD]
  )

  useEffect(() => {
    if (!loading) return

    const timer = setTimeout(() => {
      if (loading) {
        if (!skipQuery) getFlags()
        setLDOffline(true)
      }
    }, 2000)

    return () => clearTimeout(timer)
  }, [getFlags, loading, skipQuery])

  if (LDOffline && !loadingValues && !!flagValues) {
    return { flags: flagValues.flagValues, loading: loadingValues }
  }

  return { flags: flagsLD, loading }
}

export default useLDFlags
